import { gql } from '@apollo/client';

export default gql`
  mutation createSquadShiftsMembers($input: CreateSquadShiftsMembersInput!) {
    createSquadShiftsMembers(input: $input) {
      count
    }
  }
`;
